import React from 'react';
export function Hero() {
  return <section className="bg-gradient-to-b from-blue-50 to-white py-16 px-6 text-center" data-id="element-66">
      <div className="max-w-3xl mx-auto" data-id="element-67">
        <p className="text-blue-600 font-semibold uppercase tracking-widest text-sm mb-3" data-id="element-68">
          MegaPack Inglés 360 — Primaria y Secundaria
        </p>
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4" data-id="element-69">
          TODO TU AÑO DE INGLÉS
          <br data-id="element-70" />
          <span className="text-blue-600" data-id="element-71">RESUELTO.</span>
        </h1>
        <p className="text-xl text-gray-600 mb-6" data-id="element-72">
          12 tomos completos para docentes de inglés de primaria y secundaria.
          <br data-id="element-73" />
          180 actividades listas para el aula, alineadas al currículo argentino
          2026.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-8 text-sm text-gray-500" data-id="element-74">
          <span data-id="element-75">✅ 100% PDF</span>
          <span data-id="element-76">✅ Acceso inmediato</span>
          <span data-id="element-77">✅ 🇦🇷 Currículo 2026</span>
          <span data-id="element-78">✅ Pre-A1 → B2</span>
        </div>
        <a href="#precios" className="inline-block bg-blue-600 hover:bg-blue-700 text-white text-lg font-bold py-4 px-10 rounded-full shadow-lg transition" data-id="element-79">
          📚 QUIERO MI PACK DE INGLÉS AHORA
        </a>
        <div className="flex justify-center gap-6 mt-4 text-xs text-gray-400" data-id="element-80">
          <span data-id="element-81">🛡️ Garantía 7 días</span>
          <span data-id="element-82">🔒 Pago seguro</span>
          <span data-id="element-83">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}